import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageList: [],
    tabNavActiveName: '',
  },
  mutations: {
    pushPage(state, to) {

      let isAdd = true;//是否是新增
      let addIndex = -1;//如果相同，记录相同的下标
      state.pageList.forEach((item, i) => {
        if (item.to.name == to.name) {
          // 路由已存在
          isAdd = false;
          addIndex = i;
          return;
        }
      });

      // 路由信息不能全存储，定义map仅储存主要部分。
      let map = ['name', 'path', 'query', 'meta'];
      let to_ = {};
      for (let i = 0; i < map.length; i++) {
        to_[map[i]] = to[map[i]];
      }

      // 如果上面的判断需要添加
      if (isAdd) {
        // 插入记录
        state.pageList.push({
          title: to.meta.title,
          to: to_
        });
      } else {
        // 更新to记录
        state.pageList[addIndex].to = to_;
      }
      state.tabNavActiveName = to.name;

      localStorage['tabNavActiveName'] = this.tabNavActiveName;

    }
  },
  actions: {

  }
})
